import React, {Component} from 'react';
import {connect} from "react-redux";
import {hideModal} from "../../../actions/nodeEditorPanelActions";
import SelectBoxWithLabel from "../components/SelectBoxWithLabel";
import Axios from "axios";
import getAxiosConfig from "../../../utils/axiosConfig";
import {clickedNodeAction} from '../../../actions/clickedNodeActions';
import {showToastForBackend} from "../../../actions/toastActions";
import SelectBox from "../components/SelectBox";
import CheckBox from "../components/CheckBox";
import InputWithLabel from "../components/InputWithLabel";
import ContentWithTopLabel from "../components/ContentWithTopLabel";
import {removePort, addPort} from '../components/InputPortListUtils/InputPortUtils';
import uniqueId from "lodash/uniqueId";
import logicGraphDataActions from "../../../actions/logicGraphDataActions";
import ToggleMaxResultBox from "../components/ToggleMaxResultBox";
import Predicate from "../components/Predicate";
import PanelLayout from "../components/PanelLayout";


class CommonPanel extends Component {
    constructor(props) {
        super(props);
        this.state = {
            SFBPredictor: "",
            predictors: [],
            itemProperties: [],
            portList: [],
            scoringOptions: {
                predictorContextItemsPropertyName: this.props.contextProperties.length > 0 ? this.props.contextProperties[0].name : "",
                predictorContextUserPropertyName: this.props.contextProperties.length > 0 ? this.props.contextProperties[0].name : "",
                isMaxResultsSelected: true,
                predictorName: "",
                isFirstBlockModeEnabled: this.props.clickedNodeInfo.extras.options?.scoringOptions?.isFirstBlockModeEnabled || false,
                outputDynamicPropertyName: "",
                predicate_default: this.props.clickedNodeInfo.extras.options?.scoringOptions?.predicate_default,
                maxResults: "500",
                settings: {}
            },
            selectedTab: "NodeDetail"
        };
        this.handleChange = this.handleChange.bind(this);
        this.updateOptions = this.updateOptions.bind(this);
        this.changeTab = this.changeTab.bind(this);
        this.updateSettings = this.updateSettings.bind(this);
        this.removePort = this.removePort.bind(this);
        this.addPort = this.addPort.bind(this);
        this.updatePredicateTypes = this.updatePredicateTypes.bind(this);
        this.updatePredicateOptions = this.updatePredicateOptions.bind(this);
    }

    componentDidMount() {
        if (this.props.clickedNodeInfo.extras.options && this.props.clickedNodeInfo.extras.options.scoringOptions && this.props.clickedNodeInfo.extras.options.scoringOptions.predictorName !== null) {
            this.setState({scoringOptions: this.props.clickedNodeInfo.extras.options.scoringOptions}, () => {
                this.updateOptions();
            });
        } else {
            this.updateOptions();
        }
        //For SelectBox component
        let config = getAxiosConfig();
        config["params"] = {firstBlock: true};
        this.setState({
            portList: this.createPortList(this.props.clickedNodeInfo.ports),
            isFirstBlockModeEnabled: this.props.clickedNodeInfo.extras.options?.scoringOptions?.isFirstBlockModeEnabled
        });
        Axios.get(this.props.properties.logicUrl + "/predictors", config)
            .then(predictorList => {
                let predictorListSorted = predictorList.data.sort(
                    (a, b) => a.readableName > b.readableName ? 1 : -1
                );
                if (this.state.scoringOptions.predictorName === "") {
                    this.setState(prevState => ({
                        predictors: predictorListSorted,
                        scoringOptions: {
                            ...prevState.scoringOptions,
                            predictorName: predictorListSorted[0].predictorName
                        }
                    }), () => {
                        this.updateOptions();
                    });
                } else {
                    this.setState({predictors: predictorListSorted}, () => {
                        this.updatePredicateTypes();
                    });
                }
            })
            .catch(err => {
                if (err.response) {
                    this.props.showToastForBackend(err.response.data);
                }
            });
    }

    updateOptions() {
        const scoringOptions = this.state.scoringOptions;
        const clickedNodeInfo = this.props.clickedNodeInfo;

        let panelInfo = Object.assign({}, clickedNodeInfo);
        if (!Object.prototype.hasOwnProperty.call(panelInfo.extras, "options")) {
            panelInfo.extras.options = {};
        }
        panelInfo.extras.options.scoringOptions = scoringOptions;

        this.props.clickedNodeAction(panelInfo);
    }

    updatePredicateOptions(predicate_name, predicate) {
        const clickedNodeInfo = this.props.clickedNodeInfo;
        let predicateInfo = Object.assign({}, clickedNodeInfo);
        if (!Object.prototype.hasOwnProperty.call(predicateInfo.extras, "options")) {
            predicateInfo.extras.options = {};
        }

        predicateInfo.extras.options.scoringOptions.settings[predicate_name] = predicate;

        this.props.clickedNodeAction(predicateInfo);
    }

    updateSettings(property, value, valueType) {
        this.setState(prevState => ({
            scoringOptions: {
                ...prevState.scoringOptions,
                settings: {
                    ...prevState.scoringOptions.settings,
                    [property]: value
                }
            }
        }), () => {
            this.updateOptions();
        });
    }

    handleChange(property, value) {
        this.setState(prevState => ({
            scoringOptions: {
                ...prevState.scoringOptions,
                [property]: value
            }
        }), () => {
            this.updateOptions();
            this.updatePredicateTypes();
        });
    }

    changeTab(event) {
        this.setState({selectedTab: event.currentTarget.dataset.id});
    }

    removePort(item) {
        const portList = removePort(this.state.portList, item);
        this.setState({
            portList: portList
        }, () => this.updatePortOption());

    }

    updatePortOption() {
        const inputPortData = [];
        const portList = Object.values(Object.assign({}, this.state.portList));

        const inputPortList = portList.filter(port => port.in);
        inputPortList.forEach(v => {
            inputPortData.push({
                logDecisionValue: v.logDecisionValue,
                predicate: v.predicate
            });
        });

        const options = Object.assign(this.props.clickedNodeInfo.extras.options, this.state.options);
        options.chosenLogic = this.state.chosenLogic
        options.inputPortData = inputPortData;
        options.logDecisionName = this.props.clickedNodeInfo.extras.options.logDecisionName;

        const logicGraphData = {
            options: options,
            portList: portList,
            id: this.props.clickedNodeInfo.options.id
        }
        this.props.logicGraphDataActions(logicGraphData);
    }

    addPort() {
        const portList = addPort(this.state, this.props.clickedNodeInfo.options.id, 'scoring');
        this.setState({
            portList: portList
        }, () => this.updatePortOption());
    }

    setInput(isRequired) {
        const portList = this.state.portList
        const inPort = Object.values(portList).find(port => port.in)
        if (!isRequired && inPort) this.removePort(inPort);
        if (isRequired && !inPort) this.addPort();
    }

    createPortList(ports) {
        const portList = [];
        const clickedNodeInfo = Object.assign({}, this.props.clickedNodeInfo);
        Object.values(ports).forEach((v, i) => {
            const createData = {
                parentID: clickedNodeInfo.options.id,
                id: v.options.id,
                nodeName: 'Empty Input',
                branchName: '',
                groupID: uniqueId(),
                index: i,
                roundRobin: false,
                edit: false,
                sectionType: 'empty',
                groupData: {
                    groupID: uniqueId(),
                    rounds: 1,
                    randomizeAllRounds: false,
                    randomizeInsideRound: false
                },
                exclude: false,
                itemCount: null,
                logDecisionValue: '',
                randomize: false,
                useUnder: null,
                in: v.options.in
            }
            portList.push(createData);
        });
        return portList;
    }

    updatePredicateTypes() {
        let valueTypes = {};
        const predictors = this.state.predictors;
        const predictorName = this.state.scoringOptions.predictorName;
        const selectedPredictorSettings = predictors.filter(predictor => predictor.predictorName === predictorName)[0]?.possibleSettings;
        selectedPredictorSettings?.forEach((possibleSetting) => valueTypes[possibleSetting.settingName.id] = possibleSetting.settingValue.type);

        const clickedNodeInfo = this.props.clickedNodeInfo;
        let panelInfo = Object.assign({}, clickedNodeInfo);
        panelInfo.extras.options.scoringOptions.valueTypes = valueTypes;
        this.props.clickedNodeAction(panelInfo);
    }

    render() {
        const displaySettingAccordingToType = (settingValue, name, property, index) => {
            if (settingValue.type === "CONTEXT_PARAMETER" || settingValue.type === "CONTEXT_PARAMETER_NAME") {
                return <div className="filter-group" key={name + index}>
                    <div className="filter-group-content">
                        <div className="filter-rule">
                            <div className="rule-container padded right-section entire">
                                <span className="select-label">{name}:</span>
                                <SelectBox
                                    handleChangeSelect={(event) => this.updateSettings(property, event.target.value, settingValue.type)}
                                    selectValue={this.state.scoringOptions.settings !== undefined && this.state.scoringOptions.settings[property] !== undefined ? this.state.scoringOptions.settings[property] : ""}
                                    selectArray={this.props.contextProperties.sort(
                                        (a, b) => a.name > b.name ? 1 : -1
                                    ).map(function (contextProperty) {
                                        return {label: contextProperty.name, value: contextProperty.name}
                                    })}
                                    showDefault={true}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            }
            if (settingValue.type === "OPTIONS") {
                return <div className="filter-group" key={name + index}>
                    <div className="filter-group-content">
                        <div className="filter-rule">
                            <div className="rule-container padded right-section entire">
                                <span className="select-label">{name}:</span>
                                <SelectBox
                                    handleChangeSelect={(event) => this.updateSettings(property, event.target.value, settingValue.type)}
                                    selectValue={this.state.scoringOptions.settings !== undefined && this.state.scoringOptions.settings[property] !== undefined ? this.state.scoringOptions.settings[property] : ""}
                                    selectArray={settingValue.options.sort(
                                        (a, b) => a.optionReadableName > b.optionReadableName ? 1 : -1
                                    ).map(function (option) {
                                        return {label: option.optionReadableName, value: option.optionid}
                                    })}
                                    showDefault={true}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            }
            if (settingValue.type === "ITEM_PROPERTY") {
                return <div className="filter-group" key={name + index}>
                    <div className="filter-group-content">
                        <div className="filter-rule">
                            <div className="rule-container padded right-section entire">
                                <span className="select-label">{name}:</span>
                                <SelectBox
                                    handleChangeSelect={(event) => this.updateSettings(property, event.target.value, settingValue.type)}
                                    selectValue={this.state.scoringOptions.settings !== undefined && this.state.scoringOptions.settings[property] !== undefined ? this.state.scoringOptions.settings[property] : ""}
                                    selectArray={this.state.itemProperties.sort(
                                        (a, b) => a > b ? 1 : -1
                                    ).map(function (itemProperty) {
                                        return {label: itemProperty, value: itemProperty}
                                    })}
                                    showDefault={true}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            }
            if (settingValue.type === "CONSTANT") {
                return <div className="filter-group" key={name + index}>
                    <div className="filter-group-content">
                        <div className="filter-rule">
                            <InputWithLabel label={name + ":"}
                                            handleChange={(event) => this.updateSettings(property, event.target.value, settingValue.type)}
                                            value={this.state.scoringOptions.settings !== undefined && this.state.scoringOptions.settings[property] !== undefined ? this.state.scoringOptions.settings[property] : ""}
                            />
                        </div>
                    </div>
                </div>
            }
            if (settingValue.type === "SEARCH_CONDITION") {
                return <Predicate key={name + index}
                                  predicate={this.state.scoringOptions.settings !== undefined && this.state.scoringOptions.settings[property] !== undefined ? this.state.scoringOptions.settings[property] : predicate_default}
                                  updateOptions={(predicate) => this.updatePredicateOptions(property, predicate)}
                                  predicateBlockType={"searchFirst"}
                />
            }
        };

        const {clickedNodeInfo} = this.props;
        const predicate_default = clickedNodeInfo.extras?.options?.scoringOptions?.predicate_default;
        const selectedPredictors = this.state.predictors.filter(predictor => predictor.predictorName === this.state.scoringOptions.predictorName);


        return (
            <PanelLayout>
                {this.props.SFBPredictor !== true &&
                    <>
                        <CheckBox
                            isSelected={this.state.scoringOptions.isFirstBlockModeEnabled}
                            toggleInput={() => {
                                this.handleChange("isFirstBlockModeEnabled", !this.state.scoringOptions.isFirstBlockModeEnabled)
                                this.setInput(this.state.scoringOptions.isFirstBlockModeEnabled)
                            }}
                            label="First block mode"
                        />
                        <SelectBoxWithLabel
                            selectValue={this.state.scoringOptions.predictorName}
                            selectArray={
                                this.state.predictors.map(predictor => ({
                                    label: predictor.readableName,
                                    value: predictor.predictorName
                                }))
                            }
                            handleChangeSelect={(event) => this.handleChange("predictorName", event.target.value)}
                            label="Predictor Type"
                        />
                    </>
                }

                {selectedPredictors.length > 0 && selectedPredictors[0].possibleSettings.map((setting, index) => (
                    displaySettingAccordingToType(setting.settingValue, setting.settingName.readableName, setting.settingName.id, index)
                ))}

                <ToggleMaxResultBox/>
                <ContentWithTopLabel label="Output Score Name">
                    <InputWithLabel
                        label="Output Dynamic Property Name:"
                        handleChange={event => this.handleChange("outputDynamicPropertyName", event.target.value)}
                        value={this.state.scoringOptions.outputDynamicPropertyName}
                    />
                </ContentWithTopLabel>
            </PanelLayout>
        );
    }
}

function mapStateToProps(state) {
    return {
        node: state.modalInfo.node,
        properties: state.properties,
        clickedNodeInfo: state.clickedNodeInfo,
        contextProperties: state.contextProperties,
        logicDataInfo: state.logicDataInfo,
        logicGraphData: state.logicGraphData
    }
}

export default connect(mapStateToProps, {
    hideModal,
    showToastForBackend,
    clickedNodeAction,
    logicGraphDataActions
})(CommonPanel);